import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rkt",
  "use": "icon-rkt-usage",
  "viewBox": "0 0 34 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 38\" id=\"icon-rkt\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#037BFF\" d=\"M17 0l16.454 9.5v19L17 38 .546 28.5v-19z\" /><path d=\"M26 14.556H8V11.89c0-.492.403-.89.9-.89h16.2c.497 0 .9.398.9.89v2.666zm0 3.555v8a.895.895 0 01-.9.889H8.9a.895.895 0 01-.9-.889v-8h18z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol